angular.module 'zc.projects.campaigns'

.config ($stateProvider) ->

  $stateProvider
  .state 'admin.projects.campaigns',
    url: '/campaigns'
    abstract: true
    resolve:
      project: (Project, Devise, $state, $stateParams) ->
        # forward to maintenance if project is in maintenance mode
        Project.getCurrent($stateParams.projectId).then (project) ->
          if project.is_maintenance && !Devise.isMaster()
            $state.go 'admin.projects.maintenance', { projectId: $stateParams.projectId }
          project
      incentives: (Project, Incentive, $stateParams) ->
        # Get project before incentives so that
        # the correct timezone can be applied for incentives
        Project.getCurrent($stateParams.projectId).then (project) ->
          Incentive.all($stateParams.projectId, { before_end: true })

  .state 'admin.projects.campaigns.list',
    url: ''
    views:
      'content@':
        templateUrl: '/templates/projects.campaigns/list.html'
        controller: 'CampaignsCtrl'
    resolve:
      campaigns: (Campaign, $stateParams) ->
        Campaign.all {projectId: $stateParams.projectId }
      interestWidgets: (InterestWidget, project) ->
        InterestWidget.all project.apikey

  .state 'admin.projects.campaigns.add_coupons',
    url: '/add_coupons'
    views:
      'content@':
        templateUrl: '/templates/projects.campaigns/add_coupons.html'
        controller: 'AddCouponsCtrl'
        resolve:
          campaigns: (Campaign, $stateParams) ->
            Campaign.all {projectId: $stateParams.projectId }
          project: (Project, Devise, $state, $stateParams) ->
            Project.getCurrent($stateParams.projectId).then (project) ->
              if project.is_maintenance && !Devise.isMaster()
                $state.go 'admin.projects.maintenance',

  .state 'admin.projects.campaigns.show',
    url: '/{campaignId:int}'
    views:
      'content@':
        templateUrl: '/templates/projects.campaigns/show.html'
        controller: 'CampaignCtrl'
        resolve:
          campaign: (Campaign, $stateParams) ->
            Campaign.get({projectId: $stateParams.projectId, campaignId: $stateParams.campaignId})
          campaignEventOrder: (Campaign, $stateParams) ->
            Campaign.campaignEventOrder(projectId: $stateParams.projectId, campaignId: $stateParams.campaignId)
          campaignEventNotices: (Campaign, $stateParams) ->
            Campaign.campaignEventNotices(projectId: $stateParams.projectId, campaignId: $stateParams.campaignId)
          githubUrl: (Campaign, $stateParams) ->
            Campaign.githubUrl(projectId: $stateParams.projectId, campaignId: $stateParams.campaignId)
          interestWidgets: (InterestWidget, project) ->
            InterestWidget.all project.apikey

  .state 'admin.projects.campaigns.show.stats',
    url: '/stats'
    views:
      'campaignView@admin.projects.campaigns.show':
        templateUrl: '/templates/projects.campaigns/show_stats.html'

  .state 'admin.projects.campaigns.show.creative',
    url: '/creative'
    views:
      'campaignView@admin.projects.campaigns.show':
        templateUrl: '/templates/projects.campaigns/show_creative.html'

  .state 'admin.projects.campaigns.show.segment',
    url: '/segment'
    views:
      'campaignView@admin.projects.campaigns.show':
        templateUrl: '/templates/projects.campaigns/show_segment.html'

  .state 'admin.projects.campaigns.show.incentive',
    url: '/incentive'
    views:
      'campaignView@admin.projects.campaigns.show':
        templateUrl: '/templates/projects.campaigns/show_incentive.html'

  .state 'admin.projects.campaigns.show.clearance',
    url: '/clearance'
    views:
      'campaignView@admin.projects.campaigns.show':
        templateUrl: '/templates/projects.campaigns/show_clearance.html'

  .state 'admin.projects.campaigns.show.moment',
    url: '/moment'
    views:
      'campaignView@admin.projects.campaigns.show':
        templateUrl: '/templates/projects.campaigns/show_moment.html'

  .state 'admin.projects.campaigns.show.interestWidget',
    url: '/interest_widget'
    views:
      'campaignView@admin.projects.campaigns.show':
        templateUrl: '/templates/projects.campaigns/show_interest_widget.html'

  .state 'admin.projects.campaigns.show.notes',
    url: '/notes'
    views:
      'campaignView@admin.projects.campaigns.show':
        templateUrl: '/templates/projects.campaigns/show_notes.html'

  .state 'admin.projects.campaigns.edit',
    url: '/{campaignId:int}/edit'
    views:
      'content@':
        templateUrl: '/templates/projects.campaigns/edit.html'
        controller: 'EditCampaignCtrl'
        resolve:
          campaign: (Campaign, $stateParams) ->
            Campaign.get({projectId: $stateParams.projectId, campaignId: $stateParams.campaignId})
          pageTypes: ($stateParams, PageType) ->
            PageType.all($stateParams.projectId).then (pageTypes) ->
              _.uniq _.map pageTypes, (pageType) ->
                if pageType.page_type == '_custom_'
                  return pageType.custom_name
                return pageType.page_type

          templates: (Template, $stateParams) ->
            Template.all($stateParams.projectId, {active: true})
          incentives: (Incentive, $stateParams) ->
            Incentive.all($stateParams.projectId,{before_end: true})
          interestWidget: ($stateParams, InterestWidget, project) ->
            {}
          configurationTypes: (Meta) ->
            Meta.getConfigurationTypes()

  .state 'admin.projects.campaigns.edit.base',
    url: '/base'

  .state 'admin.projects.campaigns.edit.template',
    url: '/template'

  .state 'admin.projects.campaigns.edit.botbonnie',
    url: '/botbonnie'

  .state 'admin.projects.campaigns.edit.incentive',
    url: '/incentive'

  .state 'admin.projects.campaigns.edit.policy',
    url: '/policy'

  .state 'admin.projects.campaigns.edit.timing',
    url: '/timing'

  .state 'admin.projects.campaigns.edit.schedule',
    url: '/schedule'

  .state 'admin.projects.campaigns.edit.confirm',
    url: '/confirm'

  .state 'admin.projects.campaigns.confirm',
    url: '/{campaignId:int}/confirm'
    views:
      'content@':
        templateUrl: '/templates/projects.campaigns/confirm.html'
        controller: 'ConfirmCampaignCtrl'
        resolve:
          campaign: (Campaign, $stateParams) ->
            Campaign.get({projectId: $stateParams.projectId, campaignId: $stateParams.campaignId})
          templates: (Template, $stateParams) ->
            Template.all($stateParams.projectId)



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/routes.js.coffee